<template>
  <v-container py-0>
    <Navbar
      :hasDrawer="true"
      title="Configurações"
    >
      <template slot="actions">
        <v-btn
          text
          @click="save"
        >Salvar</v-btn>
        <Menu
          :items="menuItems"
          @getConfiguracoes="getBackupUsuarioConfiguracoes"
          @getBackups="getBackupsOnline"
          @executeBackup="handleExecuteBackup"
          @syncBackend="handleSyncBackend"
        />
      </template>
    </Navbar>
    <v-row>
      <v-col cols="12" class="pb-0">
        <Modal
          title="Obtendo registros"
          cardTitleClass="primary white--text"
          :modal="modalSync"
          :titleIcons="[{ name: 'mdi-close', event: 'close', dark: true }]"
          :hasActions="false"
          @close="closeModalSync"
        >
          <div v-if="loading" class="d-flex flex-column justify-center align-center">
            <v-progress-circular
              :size="50"
              color="primary"
              indeterminate
            ></v-progress-circular>
            <span class="pt-5 body-1">Aguarde...</span>
          </div>
          <div v-else class="d-flex flex-column justify-center align-center">
            <v-icon x-large color="success">mdi-check-circle</v-icon>
            <span class="pt-5 body-1">Sincronização realizada</span>
          </div>
        </Modal>
        <Modal
          title="Realizando backup"
          cardTitleClass="primary white--text"
          :modal="modalExecuteBackup"
          :titleIcons="[{ name: 'mdi-close', event: 'close', dark: true }]"
          :hasActions="false"
          @close="closeModalExecuteBackup"
        >
          <div v-if="loading" class="d-flex flex-column justify-center align-center">
            <v-progress-circular
              :size="50"
              color="primary"
              indeterminate
            ></v-progress-circular>
            <span class="pt-5 body-1">Aguarde...</span>
          </div>
          <div v-else class="d-flex flex-column justify-center align-center">
            <v-icon x-large color="success">mdi-check-circle</v-icon>
            <span class="pt-5 body-1">Backup realizado</span>
          </div>
        </Modal>
        <Modal
          title="Configurações"
          cardTitleClass="primary white--text"
          :width="computedWidth"
          :modal="modalConfiguracoes"
          :hasActions="false"
          :titleIcons="titleIcons"
          @save="saveConfiguracoesOnline"
          @close="modalConfiguracoes = false"
        >
          <div v-if="!!configuracoesOnline">
            <h4 class="mb-3">Servidor</h4>
            <v-card>
              <v-card-text class="py-0">
                <v-row>
                  <v-col cols="12">
                    <p class="mb-0 font-weight-bold">Host</p>
                    <span class="body-2">{{ configuracoesOnline.host || 'Não definido' }}</span>
                  </v-col>
                  <v-col cols="6">
                    <p class="mb-0 font-weight-bold">Incrementa Qtde</p>
                    <span class="body-2">{{ configuracoesOnline.incrementQtdeBy || 'Não definido' }}</span>
                  </v-col>
                  <v-col cols="6">
                    <p class="mb-0 font-weight-bold">ID Colaborador</p>
                    <span class="body-2">{{ configuracoesOnline.idColaborador || 'Não definido' }}</span>
                  </v-col>
                  <v-col cols="6">
                    <p class="mb-0 font-weight-bold">Validade Orçamento</p>
                    <span class="body-2">{{ configuracoesOnline.validadeOrcamento || 'Não definido' }}</span>
                  </v-col>
                  <v-col cols="6">
                    <p class="mb-0 font-weight-bold">Colaborador</p>
                    <span class="body-2">{{ configuracoesOnline.colaborador || 'Não definido' }}</span>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <h4 class="mt-5 mb-3">Orçamento</h4>
            <v-card>
              <v-card-text class="py-0">
                <v-row>
                  <v-col
                    cols="12"
                    v-for="config of configuracoesOnline.configuracoes"
                    :key="config.id"
                  >
                    <p class="mb-0 font-weight-bold">{{ config.description }}</p>
                    <span class="body-2">{{ config.value ? 'Sim' : 'Não definido' }}</span>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </div>
          <div v-else-if="loading" class="pt-5 d-flex flex-column justify-center align-center">
            <v-progress-circular
              :size="50"
              color="primary"
              indeterminate
            ></v-progress-circular>
            <span class="pt-5 body-1">Aguarde...</span>
          </div>
          <p v-else class="mb-0 text-center body-2">Nenhuma configuração encontrada</p>
        </Modal>
        <Modal
          title="Backup Online"
          cardTitleClass="primary white--text"
          :width="computedWidth"
          :modal="modalBackups"
          :hasActions="false"
          :titleIcons="titleIcons"
          @save="saveBackupsOnline"
          @close="closeModalBackups"
        >
          <div v-if="!!backupsOnline && !loading">
            <div class="d-flex justify-space-between align-center">
              <h4>Data Backup</h4>
              <p class="mb-0 body-2">{{ backupsOnline.data_backup | dateTime }}</p>
            </div>

            <v-divider class="my-3"></v-divider>

            <div class="d-flex justify-space-between align-center">
              <p class="body-2">Configurações ({{ backupsOnline.configuracoes && 1 || 0 }})</p>
            </div>

            <div class="d-flex justify-space-between align-center">
              <p class="body-2">Pedidos ({{ backupsOnline.saidas && backupsOnline.saidas.length || 0 }})</p>
            </div>

            <div class="d-flex justify-space-between align-center">
              <p class="body-2">Clientes ({{ backupsOnline.clientes && backupsOnline.clientes.length || 0 }})</p>
            </div>

            <div class="d-flex justify-space-between align-center">
              <p class="body-2">Produtos ({{ backupsOnline.produtos && backupsOnline.produtos.length || 0 }})</p>
            </div>

            <div class="d-flex justify-space-between align-center">
              <p class="body-2">Unidades ({{ backupsOnline.unidades && backupsOnline.unidades.length || 0 }})</p>
            </div>

            <div class="d-flex justify-space-between align-center">
              <p class="body-2">Condições Pagamento ({{ backupsOnline.condicoes_pagamento && backupsOnline.condicoes_pagamento.length || 0 }})</p>
            </div>

            <div class="d-flex justify-space-between align-center">
              <p class="body-2">Tipos Documento ({{ backupsOnline.tipos_documento && backupsOnline.tipos_documento.length || 0 }})</p>
            </div>

            <div class="d-flex justify-space-between align-center">
              <p class="body-2">Tabelas Preco ({{ backupsOnline.tabelas_preco && backupsOnline.tabelas_preco.length || 0 }})</p>
            </div>

            <div class="d-flex justify-space-between align-center">
              <p class="body-2">Empresas ({{ backupsOnline.empresas && backupsOnline.empresas.length || 0 }})</p>
            </div>
          </div>
          <div v-else-if="loading" class="pt-5 d-flex flex-column justify-center align-center">
            <v-progress-circular
              :size="50"
              color="primary"
              indeterminate
            ></v-progress-circular>
            <span class="pt-5 body-1">Aguarde...</span>
          </div>
          <div v-else-if="backupRestored" class="pt-5 d-flex flex-column justify-center align-center">
            <v-icon x-large color="success">mdi-check-circle</v-icon>
            <span class="pt-5 body-1">Backup restaurado</span>
          </div>
          <p v-else class="mb-0 text-center body-2">Nenhum backup encontrado</p>
        </Modal>
        <v-alert
          v-if="error"
          dense
          outlined
          type="error"
        >
          <strong>{{ error }}</strong>
        </v-alert>
        <div class="d-flex justify-space-between align-center mb-3">
          <h5 class="text-uppercase">Servidor</h5>
          <v-btn
            small
            :color="btnTestColor"
            :loading="loading"
            @click="testServidor"
          >
            <v-icon small left v-if="testOk || testError">{{ btnTestIcon }}</v-icon>
            {{ btnTestText }}
          </v-btn>
        </div>
        <v-card>
          <v-card-text>
            <v-row>
              <!-- Host -->
              <v-col cols="12">
                <v-text-field
                  v-model="host"
                  label="Host"
                  type="url"
                  placeholder="Ex: http://meudominio.com/api"
                  outlined
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="incrementQtdeBy"
                  type="number"
                  label="Incrementa Qtde"
                  placeholder="Incrementa Qtde por"
                  outlined
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="idColaborador"
                  type="number"
                  label="ID Colaborador"
                  placeholder="Código Colaborador"
                  outlined
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="validadeOrcamento"
                  type="number"
                  label="Validade Orçamento"
                  placeholder="Exemplo: 30"
                  outlined
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="colaborador"
                  label="Colaborador"
                  placeholder="Exemplo: José"
                  outlined
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <!-- Orçamentos -->
      <v-col v-if="configuracoes.length" cols="12" class="pb-0">
        <h5 class="text-uppercase mb-3">Orçamento</h5>
        <v-list class="py-0" elevation="1">
          <v-list-item
            class="pr-0"
            v-for="(config, i) of configuracoes"
            :key="i"
          >
            <v-list-item-content :class="i !== configuracoes.length -1 ? 'pb-0' : ''">
              <v-row no-gutters>
                <v-col cols="10" align-self="center">
                  {{ config.description }}
                </v-col>
                <v-col cols="2">
                  <v-switch hide-details class="ma-0" v-model="config.value"></v-switch>
                </v-col>
              </v-row>
              <v-divider class="mt-3" v-if="i !== configuracoes.length - 1" :key="i"></v-divider>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-col>
      <!-- Backups -->
      <v-col cols="12" class="pb-0">
        <h5 class="text-uppercase mb-3">Backup</h5>
        <v-list class="py-0" elevation="1">
          <v-list-item class="pr-0">
            <v-list-item-content>
              <v-row no-gutters>
                <v-col cols="7" align-self="center">
                  Realizar backup a cada
                </v-col>
                <v-col cols="4">
                  <v-select
                    v-model="backupTimeInMinutes"
                    :items="backupTimeItems"
                    dense
                    hide-details
                    filled
                  ></v-select>
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-col>
      <!-- Layout -->
      <v-col v-if="configLayout.length" cols="12" class="pb-0">
        <h5 class="text-uppercase mb-3">Layout</h5>
        <v-list class="py-0" elevation="1">
          <v-list-item
            class="pr-0"
            v-for="(config, i) of configLayout"
            :key="i"
          >
            <v-list-item-content :class="i !== configLayout.length -1 ? 'pb-0' : ''">
              <v-row no-gutters>
                <v-col cols="10" align-self="center">
                  {{ config.description }}
                </v-col>
                <v-col cols="2">
                  <v-switch hide-details class="ma-0" v-model="config.value"></v-switch>
                </v-col>
              </v-row>
              <v-divider class="mt-3" v-if="i !== configLayout.length - 1" :key="i"></v-divider>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-col>
      <!-- Banco de Dados -->
      <v-col cols="12" class="pb-0">
        <h5 class="text-uppercase mb-3">Banco de Dados Local</h5>
        <v-card>
          <v-card-text>
            <v-btn
              block
              outlined
              color="error"
              @click="deleteDb"
            >Excluir</v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import idbService from '@/services/idbService';
import { usuarioService } from '@/services/usuarioService';
import { testApiV1Service } from '@/services/testApiV1Service';

export default {
  name: 'Configuracoes',
  components: {
    Menu: () => import('@/components/shared/Menu'),
    Modal: () => import('@/components/shared/Modal'),
  },
  data: () => ({
    testOk: false,
    testError: false,
    error: '',
    loading: false,
    configuracoesOnline: null,
    modalConfiguracoes: false,
    modalBackups: false,
    modalExecuteBackup: false,
    backupsOnline: null,
    modalSync: false,
    backupRestored: false,
    showBackupsOnlineSaidas: false,
    showBackupsOnlineClientes: false,
    backupTimeItems: [
      { text: '5 minutos', value: 5 },
      { text: '10 minutos', value: 10 },
      { text: '15 minutos', value: 15 },
      { text: '30 minutos', value: 30 },
      { text: '1 hora', value: 60 },
    ],
    titleIcons: [
      { name: 'mdi-check', event: 'save', dark: true },
      { name: 'mdi-close', event: 'close', dark: true }
    ],
    menuItems: [
      { title: 'Configurações online', value: 'getConfiguracoes' },
      { title: 'Backups online', value: 'getBackups' },
      { title: 'Realizar backup', value: 'executeBackup' },
      { title: 'Sincronizar registros', value: 'syncBackend' },
    ]
  }),
  computed: {
    ...mapGetters(['usuario']),
    iconBackupsOnlineSaidas() {
      return this.showBackupsOnlineSaidas ? 'mdi-chevron-up' : 'mdi-chevron-down';
    },
    iconBackupsOnlineClientes() {
      return this.showBackupsOnlineClientes ? 'mdi-chevron-up' : 'mdi-chevron-down';
    },
    computedWidth() {
      return this.$vuetify.breakpoint.xs ? '100%': '500px';
    },
    host: {
      get() {
        return this.$store.state.configuracoes.host;
      },
      set(value) {
        this.$store.dispatch('setHost', value);
      }
    },
    idColaborador: {
      get() {
        return this.$store.state.configuracoes.idColaborador;
      },
      set(value) {
        this.$store.dispatch('setIdColaborador', value);
      }
    },
    colaborador: {
      get() {
        return this.$store.state.configuracoes.colaborador;
      },
      set(value) {
        this.$store.dispatch('setColaborador', value);
      }
    },
    validadeOrcamento: {
      get() {
        return this.$store.state.configuracoes.validadeOrcamento;
      },
      set(value) {
        this.$store.dispatch('setValidadeOrcamento', value);
      }
    },
    incrementQtdeBy: {
      get() {
        return this.$store.state.configuracoes.incrementQtdeBy;
      },
      set(value) {
        this.$store.dispatch('setIncrementQtdeBy', value);
      }
    },
    configuracoes: {
      get() {
        return this.$store.state.configuracoes.configuracoes;
      },
      set(value) {
        this.$store.dispatch('setConfiguracoes', value);
      }
    },
    backupTimeInMinutes: {
      get() {
        return this.$store.state.configuracoes.backupTimeInMinutes;
      },
      set(value) {
        this.$store.dispatch('setBackupTime', value);
      }
    },
    configLayout() {
      return this.$store.state.configuracoes.configLayout;
    },
    btnTestText() {
      if (this.testError) return 'Falha';
      return this.testOk ? 'Sucesso' : 'Testar Conexão';
    },
    btnTestColor() {
      if (this.testError) return 'error';
      return this.testOk ? 'success' : 'primary';
    },
    btnTestIcon() {
      return this.testOk ? 'mdi-check' : 'mdi-close';
    }
  },
  methods: {
    ...mapActions(['restoreBackup', 'syncBackend', 'verifyAndSendBackupOnline']),
    async handleExecuteBackup() {
      if (confirm('Tem certeza que deseja realizar o backup agora?')) {
        this.loading = true;
        this.modalExecuteBackup = true;

        await this.verifyAndSendBackupOnline();

        this.loading = false;
      }
    },
    changeConfiguracoes(configuracoesObj) {
      const {
          host,
          incrementQtdeBy = 1,
          idColaborador = 1,
          validadeOrcamento = 30,
          colaborador,
          configuracoes
        } = configuracoesObj;

        this.host = host;
        this.incrementQtdeBy = incrementQtdeBy;
        this.idColaborador = idColaborador;
        this.validadeOrcamento = validadeOrcamento;
        this.colaborador = colaborador;
        
        if (configuracoes) this.configuracoes = configuracoes;
    },
    saveConfiguracoesOnline() {
      if (!!this.configuracoesOnline && confirm('Tem certeza que deseja substituir as configurações atuais?')) {
        this.changeConfiguracoes({ ...this.configuracoesOnline });

        this.modalConfiguracoes = false;

        this.save();
      }
    },
    async handleSyncBackend() {
      if (
        !this.host ||
        !this.idColaborador
      ) {
        this.$store.commit('SHOW_SNACKBAR', { text: 'Configurações inválidas!', status: 'error' });
        return;
      }

      this.modalSync = true;
      this.loading = true;

      await this.syncBackend();
      
      this.loading = false;
      
      const { sync } = this.$route.query;

      if (sync) this.$router.push({ query: {} });
    },
    closeModalExecuteBackup() {
      if (!this.loading) this.modalExecuteBackup = false;
    },
    closeModalSync() {
      if (!this.loading) this.modalSync = false;
    },
    closeModalBackups() {
      if (!this.loading) this.modalBackups = false;
    },
    async getBackupsOnline() {
      this.backupRestored = false;
      this.modalBackups = true;
      this.loading = true;

      try {
        const { data } = await usuarioService.getBackups(this.usuario._id, 'completo');
        this.backupsOnline = data.data;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    async saveBackupsOnline() {
      if (!!this.backupsOnline && confirm('Tem certeza que deseja restaurar o backup?')) {
        this.loading = true;
  
        const { configuracoes } = this.backupsOnline;
  
        await this.restoreBackup({ ...this.backupsOnline });
  
        if (configuracoes) this.changeConfiguracoes({ ...this.backupsOnline.configuracoes });
  
        this.backupRestored = true;
        this.backupsOnline = null;
        this.loading = false;
        
        const { backup } = this.$route.query;
  
        if (backup) this.$router.push({ query: {} });
  
        setTimeout(async () => await this.save(), 2000);
      }
    },
    async getBackupUsuarioConfiguracoes() {
      this.loading = true;
      this.modalConfiguracoes = true;
      try {
        const { data } = await usuarioService.getBackups(this.usuario._id, 'configuracoes');
        this.configuracoesOnline = data.data;
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },
    async shouldSyncBackend() {
      const produtos = await idbService.getAll('produtos');

      const shouldSync = !(produtos && produtos.length) && !!this.host && !!this.idColaborador;

      return shouldSync;
    },
    async testServidor() {
      this.loading = true;
      this.testOk = false;
      this.testError = false;
      this.error = '';

      try {
        const response = await testApiV1Service.getConnection();
        console.log(response);
        this.loading = false;
        this.testOk = true;
      } catch (error) {
        console.log(error.message);
        this.loading = false;
        this.testOk = false;
        this.testError = true;
        this.error = error.message;
      }
    },
    async save() {
      if (this.incrementQtdeBy <= 0) this.incrementQtdeBy = 1;
      
      const configPedidos = {
        host: this.host.trim(),
        idColaborador: +this.idColaborador,
        colaborador: this.colaborador,
        validadeOrcamento: +this.validadeOrcamento,
        incrementQtdeBy: +this.incrementQtdeBy,
        backupTimeInMinutes: this.backupTimeInMinutes,
        configuracoes: this.configuracoes,
        configLayout: this.configLayout
      };

      this.$store.dispatch('saveConfiguracoes', configPedidos);
      await usuarioService.setBackups(this.usuario._id, 'configuracoes', configPedidos);
      // Após salvar as configurações a página é atualizada de forma bruta
      // para que a URL do host seja registrada como URL do axios
      const shouldSync = await this.shouldSyncBackend();
      if (shouldSync) this.$router.push({ query: { sync: true } });
      this.$router.go();
      this.$store.commit('SHOW_SNACKBAR', { text: 'Configurações salvas com sucesso!', status: 'success' });
    },
    async deleteDb() {
      if (confirm('Tem certeza que deseja excluir o banco de dados local?')) {
        await idbService.destroyDb();
        this.$router.go();
        this.$store.commit('SHOW_SNACKBAR', { text: 'Banco de dados local excluído com sucesso!', status: 'success' });
      }
    }
  },
  created() {
    const { backup, sync } = this.$route.query;

    if (backup) this.getBackupsOnline();

    if (sync) this.handleSyncBackend();
  }
}
</script>

<style>

</style>